import { render, staticRenderFns } from "./ItsSalesForeignSalesSettlement.vue?vue&type=template&id=1aec4e43&scoped=true&"
import script from "./ItsSalesForeignSalesSettlement.vue?vue&type=script&lang=js&"
export * from "./ItsSalesForeignSalesSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec4e43",
  null
  
)

export default component.exports